export var reducer = function reducer(pluginState) {
  return pluginState;
};